import { jwtDecode, JwtPayload } from "jwt-decode";

export interface InternalTokenPayload extends JwtPayload {
  email: string;
  role: string;
  cognitoSub: string;
  organizationId?: string;
  termsOfUseAccepted?: boolean;
}

export class TokenService {
  static readonly TOKEN_KEY: string = "evoly_token";

  static setInternalToken(internalToken: string): void {
    if (!internalToken) {
      return;
    }

    localStorage.setItem(this.TOKEN_KEY, internalToken);
  }

  static getInternalToken(): string | null {
    let internalToken: string | null;

    try {
      internalToken = localStorage.getItem(this.TOKEN_KEY);
    } catch {
      internalToken = null;
    }

    return internalToken;
  }

  static clearInternalToken(): void {
    try {
      localStorage.removeItem(this.TOKEN_KEY);
    } catch {
      // Ignore storage failures and continue logout/login flow.
    }
  }

  static getInternalTokenPayload(): InternalTokenPayload | null {
    const internalToken: string | null = this.getInternalToken();

    if (!internalToken) {
      return null;
    }

    let decodedInternalToken: InternalTokenPayload | null;

    try {
      decodedInternalToken = jwtDecode(internalToken);
    } catch {
      decodedInternalToken = null;
    }

    return decodedInternalToken;
  }

  static isInternalTokenValid(): boolean {
    const internalToken: string | null = this.getInternalToken();

    if (!internalToken) {
      return false;
    }

    let decodedInternalToken: InternalTokenPayload | null;

    try {
      decodedInternalToken = jwtDecode(internalToken);
    } catch {
      decodedInternalToken = null;
    }

    // Check if internal token is expired (do not remove here - let API 401 or explicit logout clear it)
    return (
      !!decodedInternalToken &&
      !!decodedInternalToken.exp &&
      Date.now() < decodedInternalToken.exp * 1000
    );
  }
}
